import { persistentClipsDns } from '@/environment';
import { ITranslation, ITranslationGroup, TranslationGroupStatus, TranslationStatus } from '@d-id/types';

export const EXAMPLE_TRANSLATION_GROUPS: ITranslationGroup[] = [
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 35,
        id: 'Marketing_campaign.mp4',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Marketing campaign',
        owner_id: 'admin',
        persist: true,
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.mp4'}`),
        status: TranslationGroupStatus.Done,
        subtitles_url: '',
        target_languages: ['french', 'german', 'italian', 'japanese'],
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        id: 'New_feature_announcement.mp4',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationGroupStatus.Done,
        subtitles_url: '',
        target_languages: ['chinese', 'french', 'german', 'japanese', 'spanish'],
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        id: 'Sales_outreach.mp4',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationGroupStatus.Done,
        subtitles_url: '',
        target_languages: ['chinese', 'dutch', 'french', 'german', 'italian', 'japanese', 'portuguese', 'russian', 'spanish'],
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
];

export const EXAMPLE_TRANSLATIONS: ITranslation[] = [
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 35,
        group_id: 'Marketing_campaign.mp4',
        id: 'Marketing_campaign_French.mp4',
        language: 'french',
        locale: 'fr-FR',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Marketing campaign',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign_French.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 35,
        group_id: 'Marketing_campaign.mp4',
        id: 'Marketing_campaign_German.mp4',
        language: 'german',
        locale: 'de-DE',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Marketing campaign',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign_German.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 35,
        group_id: 'Marketing_campaign.mp4',
        id: 'Marketing_campaign_Italian.mp4',
        language: 'italian',
        locale: 'it-IT',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Marketing campaign',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign_Italian.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 35,
        group_id: 'Marketing_campaign.mp4',
        id: 'Marketing_campaign_Japanese.mp4',
        language: 'japanese',
        locale: 'ja-JP',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Marketing campaign',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign_Japanese.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Marketing_campaign/Marketing_campaign.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        group_id: 'New_feature_announcement.mp4',
        id: 'New_feature_announcement_Chinese.mp4',
        language: 'chinese',
        locale: 'zh-CN',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement_Chinese.mp4'}`
        ),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        group_id: 'New_feature_announcement.mp4',
        id: 'New_feature_announcement_French.mp4',
        language: 'french',
        locale: 'fr-FR',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement_French.mp4'}`
        ),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        group_id: 'New_feature_announcement.mp4',
        id: 'New_feature_announcement_German.mp4',
        language: 'german',
        locale: 'de-DE',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement_German.mp4'}`
        ),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        group_id: 'New_feature_announcement.mp4',
        id: 'New_feature_announcement_Japanese.mp4',
        language: 'japanese',
        locale: 'ja-JP',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement_Japanese.mp4'}`
        ),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 14,
        group_id: 'New_feature_announcement.mp4',
        id: 'New_feature_announcement_Spanish.mp4',
        language: 'spanish',
        locale: 'es-ES',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'New feature announcement',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement_Spanish.mp4'}`
        ),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(
            `${persistentClipsDns}${'/D_ID_translation_examples/New_feature_announcement/New_feature_announcement.png'}`
        ),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Chinese.mp4',
        language: 'chinese',
        locale: 'zh-CN',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Chinese.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Dutch.mp4',
        language: 'dutch',
        locale: 'nl-NL',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Dutch.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_French.mp4',
        language: 'french',
        locale: 'fr-FR',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_French.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_German.mp4',
        language: 'german',
        locale: 'de-DE',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_German.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Italian.mp4',
        language: 'italian',
        locale: 'it-IT',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Italian.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Japanese.mp4',
        language: 'japanese',
        locale: 'ja-JP',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Japanese.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Portuguese.mp4',
        language: 'portuguese',
        locale: 'pt-PT',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Portuguese.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Russian.mp4',
        language: 'russian',
        locale: 'ru-RU',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Russian.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
    {
        created_at: '2024-08-19T00:00:00.001Z',
        created_by: 'admin',
        duration: 20,
        group_id: 'Sales_outreach.mp4',
        id: 'Sales_outreach_Spanish.mp4',
        language: 'spanish',
        locale: 'es-ES',
        modified_at: '2024-08-19T00:00:00.001Z',
        name: 'Sales outreach',
        owner_id: 'admin',
        persist: true,
        result_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach_Spanish.mp4'}`),
        source_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.mp4'}`),
        status: TranslationStatus.Done,
        subtitles: false,
        thumbnail_url: encodeURI(`${persistentClipsDns}${'/D_ID_translation_examples/Sales_outreach/Sales_outreach.png'}`),
    },
];
